/* src/lessons/Scene.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get, isEmpty, map, uniqBy, filter, find, remove, toLower } from 'lodash';
import { loadTexts } from '../../config/texts';

import { withStyles } from '@material-ui/core/styles';
import {
  Paper,
  Checkbox,
  TextField,
  Grid,
  Typography,
  Input,
  Button,
  Modal,
  Card,
} from '@material-ui/core';
import { fetchLessons } from '../lessons/actions';

import { HeaderTable, PaperHeader } from '../../app/components';
import SubsidyReceipt from '../../app/components/SubsidyReceipt';
import { getPageInfo, getLessons } from './selector';
const TEXT_KEY = "credited_history";

class CreditedHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      from: null,
      to: null,
      selectedLessons: [],
      generateReceiptData: null,
      renderReceiptModal: false,
      sort: [{ field: 'student', direction: -1 }],
      texts: loadTexts(TEXT_KEY, props.locale)
    };
  }

  componentDidMount() {
    this._onFetchLessons({});
  }

  _onSort(field, direction) {
    let { sort } = this.state;
    switch (field) {
      case 'tutor':
        sort = [{ field: 'tutor.user.first', direction }, { field: 'tutor.user.last', direction }];
        break;
      case 'student':
        sort = [{ field: 'student.user.first', direction }, { field: 'student.user.last', direction }];
        break;
      case 'credits used':
        sort = [{ field: 'creditsUsed', direction }];
        break;
      case 'time':
        sort = [{ field: 'current.start_time', direction }];
        break;
      case 'created':
        sort = [{ field: 'created_at', direction }];
        break;
      case 'course':
        sort = [{ field: 'course.subject', direction }, { field: 'course.number', direction }];
        break;
      default:
        break;
    }
    this.setState({ sort }, () => this._onFetchLessons({}));
  }

  onGenerateReceipts() {
    const { selectedLessons } = this.state;
    const { lessons } = this.props;
    const filteredLessons = filter(lessons, l =>
      selectedLessons.includes(l._id),
    );
    this.formatGenerateReceiptData(filteredLessons);
  }

  async formatGenerateReceiptData(lessons) {
    //const { studentId, student, studentUniversity }

    const studentsArray = await map(lessons, l => ({
      studentId: l.studentId,
      studentName: l.student,
      studentUniversity: l.studentUniversity,
    }));
    const uniqStudentArray = await uniqBy(studentsArray, s =>
      [s.studentId, s.studentUniversity].join(),
    );
    await map(uniqStudentArray, async s => {
      const sLessons = filter(
        lessons,
        l =>
          l.studentId === s.studentId &&
          l.studentUniversity === s.studentUniversity,
      );
      let totalCredits = 0;
      s.lessons = await map(sLessons, l => {
          totalCredits = totalCredits + parseInt(l['credits used']) * 100;
          return {
            _id: l._id,
            course: l.course,
            tutor: l.tutor,
            date: l.time,
            hours: l.duration,
            rate: (parseInt(l.price) / l.duration).toFixed(2) * 100,
            creditsUsed: parseInt(l['credits used']) * 100,
          };
        },
      );
      s.creditsUsed = totalCredits;
    });
    this.setState({
      generateReceiptData: uniqStudentArray,
      renderReceiptModal: true,
    });
    //const creditsUsed = nextProps.lessons.
  }

  async _onFetchLessons({
    university = this.props.selectedUniversity,
    organization = this.props.selectedOrganization,
  }) {
    const { sort, to, from } = this.state;
    const { page, limit } = this.props.pagination;

    const t = new Date(to);
    const f = new Date(from);
    if (!isEmpty(to) && !isEmpty(from)) {
      await this.props.fetchLessons({
        lessonSearchInput: {
          universities: [university],
          organizations: [organization],
          fetchCredits: true,
          credits: {
            startDate: { timestamp: `${f.getTime()}` },
            endDate: {
              timestamp:
                t.getTime() > f.getTime() ? `${t.getTime()}` : `${f.getTime()}`,
            },
          },
        },
        sort,
        page: { limit: 2147000000 },
        // page: { page, limit },
      });
    } else {
      await this.props.fetchLessons({
        lessonSearchInput: {
          universities: [university],
          organizations: [organization],
          fetchCredits: true,
        },
        sort,
        page: { limit: 2147000000 },
      });
    }
  }

  renderActions() {
    const { classes, selectedOrganization, selectedUniversity } = this.props;
    const { from, to, sort, selectedLessons, texts: { label, button_text } } = this.state;
    let t = new Date(to);
    t.setDate(t.getDate() + 1);
    const f = new Date(from);

    return (
      <div className={classes.actionsContainer}>
        <div className={classes.searchContainer}>
          <Input
            value={this.state.search}
            disableUnderline
            fullWidth
            onChange={event => this.setState({ search: event.target.value })}
            style={{ color: '#4153af' }}
          />
        </div>
        <div>
          <TextField
            //className={classes.startDateTextField}
            id="start_date"
            label={label.from}
            type="date"
            InputLabelProps={{ shrink: true }}
            value={from}
            onChange={event => {
              this.setState({ from: event.target.value });
              const ff = new Date(event.target.value);
              if (!isEmpty(this.state.to) && !isEmpty(event.target.value)) {
                this.props.fetchLessons({
                  lessonSearchInput: {
                    universities: [selectedUniversity],
                    organizations: [selectedOrganization],
                    fetchCredits: true,
                    credits: {
                      startDate: { timestamp: `${ff.getTime()}` },
                      endDate: {
                        timestamp:
                          t.getTime() > ff.getTime()
                            ? `${t.getTime()}`
                            : `${ff.getTime()}`,
                      },
                    },
                  },
                  sort,
                  page: { limit: 2147000000 },
                });
              }
            }}
            style={{ marginRight: 15 }}
          />
          <TextField
            //className={classes.startDateTextField}
            id="end_date"
            label={label.to}
            type="date"
            InputLabelProps={{ shrink: true }}
            value={to}
            onChange={event => {
              this.setState({ to: event.target.value });
              let tt = new Date(event.target.value);
              tt.setDate(tt.getDate() + 1);
              let ff = new Date(f);
              ff.setDate(ff.getDate() + 1);
              if (!isEmpty(event.target.value) && !isEmpty(this.state.from)) {
                this.props.fetchLessons({
                  lessonSearchInput: {
                    universities: [selectedUniversity],
                    organizations: [selectedOrganization],
                    fetchCredits: true,
                    credits: {
                      startDate: { timestamp: `${f.getTime()}` },
                      endDate: {
                        timestamp:
                          tt.getTime() > f.getTime()
                            ? `${tt.getTime()}`
                            : `${ff.getTime()}`,
                      },
                    },
                  },
                  sort,
                  page: { limit: 2147000000 },
                });
              }
            }}
            style={{ marginRight: 30 }}
          />
          <Button
            variant="contained"
            size="large"
            color="primary"
            onClick={() => this.onGenerateReceipts()}
            disabled={isEmpty(selectedLessons)}
          >
            {button_text.generate_receipts}
          </Button>
        </div>
      </div>
    );
  }

  renderReceipts() {
    const { generateReceiptData, renderReceiptModal } = this.state;
    const { classes } = this.props;
    return (
      <Modal
        id="subsidy_receipt_modal"
        open={renderReceiptModal}
        onClose={() => this.setState({ renderReceiptModal: false })}
      >
        <Card className={classes.receiptModal}>
          <SubsidyReceipt data={generateReceiptData} />
        </Card>
      </Modal>
    );
  }

  render() {
    const { selectedLessons, generateReceiptData, search, texts } = this.state;
    const filteredLesson = map(this.props.lessons, l => ({
      tutor: l.tutor,
      student: l.student,
      course: l.course,
      'credits used': l['credits used'],
      created: l.created,
      time: l.time,
      status: l.status,
      _id: l._id,
    }));
    const searchResult = search === '' ? filteredLesson : filter(
      filteredLesson,
      ({ student, tutor }) => toLower(tutor).includes(toLower(search)) || toLower(student).includes(toLower(search))
    );

    const translatedResult = map(searchResult, l => ({
      [texts.fields.tutor]: l.tutor,
      [texts.fields.student]: l.student,
      [texts.fields.course]: l.course,
      [texts.fields.credits_used]: l['credits used'],
      [texts.fields.created]: l.created,
      [texts.fields.time]: l.time,
      status: l.status,
      _id: l._id,
    }));

    return (
      <Paper>
        <PaperHeader text={texts.title.credit_history} />
        {this.renderActions()}
        <HeaderTable
          label="students"
          data={translatedResult}
          count={this.props.lessons.length}
          // onNext={this._onNextPage}
          // onPrev={this._onPrevPage}
          // loading={loading}
          hover={false}
          //onRowClick={p => this.props.history.push('/home/subsidy/program', { program: p })}
          onSort={({ field, direction }) => this._onSort(field, direction)}
          sortEnabled
          showCheckbox
          onCheckRow={d => {
            let temp = selectedLessons;
            if (!isEmpty(find(temp, i => i == d._id))) {
              remove(temp, i => i == d._id);
            } else {
              temp.push(d._id);
            }
            this.setState({ selectedLessons: temp });
          }}
          onCheckAll={array => {
            const temp = map(array, i => i._id);
            this.setState({
              selectedLessons: temp,
            });
          }}
          // colored={showOnlyAvailable}
        />
        {this.renderReceipts()}
      </Paper>
    );
  }
}

const styles = theme => ({
  actionsContainer: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginRight: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
  },
  searchContainer: {
    borderRadius: 42,
    width: 340,
    paddingRight: theme.spacing.unit * 2,
    paddingLeft: theme.spacing.unit * 2,
    alignItems: 'center',
    justifyContent: 'flex-start',
    border: '2px solid #4153af',
    flexDirection: 'row',
    display: 'flex',
  },
  receiptModal: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    minWidth: 400,
    maxHeight: '90%',
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
    padding: theme.spacing.unit * 3,
    overflow: 'scroll',
  },
});

CreditedHistory.propTypes = {};

const mapStateToProps = state => ({
  selectedUniversity: state.auth.selectedUniversity,
  selectedOrganization: state.auth.selectedOrganization,
  pagination: getPageInfo(state),
  lessons: getLessons(state),
  locale: state.appState.locale
});

const mapDispatchToProps = dispatch => ({
  fetchLessons: params => dispatch(fetchLessons(params)()),
});

export default compose(
  withStyles(styles, { name: 'CreditedHistory' }),
  connect(mapStateToProps, mapDispatchToProps),
)(CreditedHistory);



// WEBPACK FOOTER //
// ./src/modules/credited_history/Scene.js